import React from "react";
import { Ok } from "react-ikonate";
import styles from "./index.module.css";
import classNames from "classnames";
import PropTypes from "prop-types";

/**
 * A basic HTML checkbox with built in styles.
 */
export default function Checkbox({ className, icon, size, ...props }) {
  const containerStyle = size
    ? {
        "--size": `${size}px`,
        "--icon-size": `${Math.round(size * (14 / 22))}px`,
      }
    : undefined;

  return (
    <div className={styles.container} style={containerStyle}>
      <input
        type="checkbox"
        className={classNames(styles.checkbox, className)}
        {...props}
      />
      <div className={styles.icon}>{icon ?? <Ok />}</div>
    </div>
  );
}

Checkbox.propTypes = {
  /**
   * Custom icon to render when checked. Defaults to the react-ikonate Ok icon.
   */
  icon: PropTypes.node,
  /**
   * Overrides the default 22px checkbox size (and scales the icon to match).
   */
  size: PropTypes.number,
};